import { DateTime } from "luxon";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { ColorGray, ColorTestPilot, IgTypography } from "@intelligems/ig-theme";
import { ExperienceAnalysisHistoryDto } from "@intelligems/ig-types";
import { Grid, ListItemButton } from "@mui/material";

import { useExperienceAnalysisHistory } from "../../../../../api/ai/experience-analysis-history";
import { SkeletonGroup } from "../../../../../components/Utils/SkeletonGroup";
import {
  dispatchExperienceAnalysis,
  experienceAnalysis,
} from "../../../../../store/slices/ai";

export const PreviousThreads = () => {
  const analysis = useSelector(experienceAnalysis);
  const dispatch = useDispatch();
  const experienceAnalysisHistory = useExperienceAnalysisHistory(
    analysis.experience?.id
  );

  const onClick = (e: ExperienceAnalysisHistoryDto) => {
    dispatch(
      dispatchExperienceAnalysis({
        type: "setThreadFromHistory",
        value: {
          assistantId: e.assistantId,
          threadId: e.threadId,
          messages: e.messages,
          createdAt: e.createdAt,
        },
      })
    );
  };

  return (
    <Grid container item direction={"column"} rowSpacing={2}>
      <Grid item>
        <IgTypography variant={"h6"}>Previous Conversations</IgTypography>
      </Grid>
      {experienceAnalysisHistory.isSuccess ? (
        experienceAnalysisHistory.data.history?.length ? (
          experienceAnalysisHistory.data.history.map((history) => (
            <Grid item key={history.threadId}>
              <ListItemButton
                selected={analysis.threadId === history.threadId}
                onClick={() => onClick(history)}
                sx={{
                  transition: "0.2s",
                  borderRadius: "4px",
                  justifyContent: "center",
                  border: `1px solid ${ColorGray.light}`,
                  "&:hover, &:focus": {
                    border: `1px solid ${ColorTestPilot.hoverBlue}`,
                  },
                  "&:focus": {
                    backgroundColor: "transparent",
                  },
                  "&.Mui-selected": {
                    backgroundColor: "rgba(49,60,104,0.1)",
                    border: `1px solid ${ColorTestPilot.hoverBlue}`,
                  },
                }}
              >
                <Grid container direction={"column"} justifyContent={"start"}>
                  <Grid item>
                    <IgTypography>{history.title || "Chat"}</IgTypography>
                  </Grid>
                  <Grid item>
                    <IgTypography
                      sx={{ color: ColorGray.contrastText, fontSize: "12px" }}
                    >
                      {DateTime.fromMillis(history.createdAt).toLocaleString(
                        DateTime.DATETIME_SHORT
                      )}
                    </IgTypography>
                  </Grid>
                </Grid>
              </ListItemButton>
            </Grid>
          ))
        ) : (
          <IgTypography>You have no prior chats</IgTypography>
        )
      ) : (
        <Grid item sx={{ width: "500px" }}>
          <SkeletonGroup lines={3} />
        </Grid>
      )}
    </Grid>
  );
};
